import axios from "axios";

export const loadAllCenterProductPriceAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&page=${
        payload.currentPage
      }&countries=[${payload.countryId}]&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&status=${payload.status}&memoryPrices=${
        payload.isMemoryPrice
      }&transports=[${payload.transports}]&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleCenterProductPriceAPI = (payload) => {
  return axios
    .get(`/relatedContacts/${payload.relatedContactId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
